import React from 'react';
import { useIntl } from 'react-intl';

import { advantages, disadvantages } from '@/assets/img';
import Icon from '@/components/Base/Icon';
import { StaticContentTitle } from '@/components/Base/StaticContent/StaticContent.styles';
import { colorAccent3, colorSecondary400 } from '@/styleUtils';

import {
  Blocks,
  BlockWrapper,
  List,
  ListItem,
  SectionTitle,
  StyledImg,
  Wrapper,
} from './Advantages.styles';

const listItems = Array.from({ length: 3 }).map((_, index) => index);

function Advantages() {
  const { formatMessage } = useIntl();

  return (
    <Wrapper id="advantages" className="sections">
      <StaticContentTitle as="h2">
        {formatMessage({
          id: 'staticContent.anchorLinks.map.title.advantages',
        })}
      </StaticContentTitle>

      <Blocks>
        <BlockWrapper>
          <StyledImg
            src={advantages}
            alt={formatMessage({
              id: 'staticContent.anchorLinks.map.title.advantages',
            })}
          />

          <SectionTitle>
            {formatMessage({
              id: 'staticContent.advantages.title',
            })}
          </SectionTitle>

          <List>
            {listItems.map((item, index) => (
              <ListItem key={index}>
                <Icon width="10" height="10" name="plus" color={colorAccent3} />

                {formatMessage({
                  id: `staticContent.advantages.${index}`,
                })}
              </ListItem>
            ))}
          </List>
        </BlockWrapper>

        <BlockWrapper>
          <StyledImg
            src={disadvantages}
            alt={formatMessage({
              id: 'staticContent.disadvantages.title',
            })}
          />

          <SectionTitle>
            {formatMessage({
              id: 'staticContent.disadvantages.title',
            })}
          </SectionTitle>

          <List>
            {listItems.map((item, index) => (
              <ListItem key={index}>
                <Icon
                  width="10"
                  height="10"
                  name="minus"
                  color={colorSecondary400}
                />

                {formatMessage({
                  id: `staticContent.disadvantages.${index}`,
                })}
              </ListItem>
            ))}
          </List>
        </BlockWrapper>
      </Blocks>
    </Wrapper>
  );
}

export default Advantages;
